import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class InstallmentServices {
  async export(params: string): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/installment/export-xlsx/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async import(params: any, data: any): Promise<any> {
    const buildParams = (params: any) => {
      const query = Object.entries(params)
        .flatMap(([key, value]: [any, any]) =>
          Array.isArray(value) 
            ? value.map(item => `${key}=${encodeURIComponent(item)}`) 
            : `${key}=${encodeURIComponent(value)}`
        )
        .join('&');
  
      return query;
  };

    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_PAYMENT}/installment/import?${buildParams(params)}`, data, {
        headers: { 'authentication-token': getJWT()! }
      })
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const installmentServices = new InstallmentServices()
